import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import SpinnerMixin from "@/mixins/spinner";
import appointmentApi from "@/api/appointment/appointmentApiHttp";
import { dateValidationRule } from "@/helpers/formValidation";
import { downloadFile } from "@/helpers/fileHelper";
// The payroll is monthly, so the period is the previous month
function getPreviousMonth() {
    const previousMonth = moment().subtract(1, "month");
    return {
        startDate: previousMonth
            .clone()
            .startOf("month")
            .toDate(),
        endDate: previousMonth
            .clone()
            .endOf("month")
            .startOf("day")
            .toDate()
    };
}
export default Vue.extend({
    mixins: [SpinnerMixin],
    data() {
        return {
            officesData: [],
            employeesData: [],
            isDataLoaded: false,
            // No offices means all of them
            officeIds: [],
            startDate: getPreviousMonth().startDate,
            endDate: getPreviousMonth().endDate,
            employeeId: null,
            validationOptions: {
                rules: {
                    employeesExportStartDate: {
                        required: true,
                        date: [dateValidationRule]
                    },
                    employeesExportEndDate: {
                        required: true,
                        date: [dateValidationRule],
                        endDateNotBeforeStartDate: [
                            (args) => {
                                const startDate = args.element.form.querySelector("#employeesExportStartDate").ej2_instances[0].value;
                                const endDate = args.element.form.querySelector("#employeesExportEndDate").ej2_instances[0].value;
                                return (startDate == null || endDate == null || endDate >= startDate);
                            },
                            this.$t("employees.export.endDateBeforeStartDateError")
                        ]
                    }
                }
            }
        };
    },
    computed: {
        ...mapGetters({
            hasMultipleOffices: "account/hasMultipleOffices"
        })
    },
    methods: {
        async exportEmployeeAppointments() {
            const request = {
                startDate: moment(this.startDate).format("YYYY-MM-DD"),
                endDate: moment(this.endDate).format("YYYY-MM-DD"),
                officeIds: this.officeIds,
                employeeId: this.employeeId ?? undefined
            };
            // The dialog is closed right away and the page spinner shows the export in progress, so any
            // failure is notified with a toast instead of the form errors
            this.$parent.$parent.hide();
            try {
                const { file, fileName } = await appointmentApi.exportEmployeeAppointments(request);
                downloadFile(file, fileName);
            }
            catch (errors) {
                this.$toast.showWarningToast(this.$t("shared.toastFailureTitle"), errors[0].message);
            }
        },
        cancel() {
            this.$parent.$parent.hide();
        },
        async onShow(officeId) {
            // Each opening starts again from the office of the page search and the previous month
            const { startDate, endDate } = getPreviousMonth();
            this.startDate = startDate;
            this.endDate = endDate;
            this.employeeId = null;
            // On the first opening the offices are loaded after the office was set, so it is set again to select it in the list
            this.officeIds = officeId != null ? [officeId] : [];
            if (!this.isDataLoaded) {
                await this.loadData();
                this.officeIds = officeId != null ? [officeId] : [];
            }
        },
        async loadData() {
            if (this.isDataLoaded)
                return;
            try {
                const offices = await this.$store.dispatch("office/getAll");
                const employees = await this.$store.dispatch("employee/getAll", {
                    load: true
                });
                // The store lists are copied, as they are shared with the other pages
                this.officesData = offices.map((office) => ({
                    id: office.id,
                    name: office.name
                }));
                this.employeesData = [
                    { id: null, fullName: this.$t("employees.all") },
                    ...employees
                        .filter(employee => employee.deletedAt == undefined)
                        .map(employee => ({
                        id: employee.id,
                        fullName: `${employee.name} ${employee.surname}`
                    }))
                ];
                this.isDataLoaded = true;
            }
            catch (errors) {
                this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                    error: errors[0].message
                }));
            }
        }
    },
    mounted() {
        // The content is created with the employees page, so the data is loaded when the dialog is first opened
        this.$parent.$parent.$on("show", this.onShow);
    },
    beforeDestroy() {
        this.$parent.$parent.$off("show", this.onShow);
    }
});
